import { render } from "./PledgeManagerInfoIntroductionBox.vue?vue&type=template&id=38b75412"
import script from "./PledgeManagerInfoIntroductionBox.vue?vue&type=script&lang=js"
export * from "./PledgeManagerInfoIntroductionBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__